<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between ">
                        <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">Pengaturan</h4>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!isLoading" class="row">
                <div class="col-md-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30 ">
                        <h5 class="mb-3">Pengaturan Pengirim WhatsApp</h5>
                        <form v-on:submit.prevent="updateSetting">
                            <label for="">Pengirim Primary</label>
                            <select v-model="setting.sender_device_id" class="form-control" required>
                                <option value="" selected disabled>== PILIH DEVICE ==</option>
                                <option v-for="d in device" :key="d.device_id" :value="d.device_id">{{ d.name }}</option>
                            </select>
                            <br>
                            <label for="">Pengirim Secondary (backup)</label>
                            <select v-model="setting.sender_device_id_backup" class="form-control" required>
                                <option value="" selected disabled>== PILIH DEVICE ==</option>
                                <option v-for="d in device" :key="d.device_id" :value="d.device_id">{{ d.name }}</option>
                            </select>
                            <br>
                            <label for="">Device ID API Eksternal (api.whacenter.com)</label>
                            <input v-model="setting.wa_api_device_id" type="text" class="form-control" placeholder="Contoh: deviceid1,deviceid2,deviceid3">
                            <small class="text-muted d-block mt-1">
                                Isi dengan device ID dari api.whacenter.com. Bisa lebih dari satu, pisahkan dengan koma —
                                sistem akan memilih device secara acak (rotate) untuk setiap pesan.
                                Jika kosong, pesan dikirim via device lokal (RabbitMQ).
                            </small>
                            <br>
                            <button type="submit" class="btn btn-success"> Simpan Pengaturan WA </button>
                        </form>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30 ">
                        <h5 class="mb-3">Pengaturan SMTP Email</h5>
                        <form v-on:submit.prevent="updateEmailSetting">
                            <div class="row">
                                <div class="col-md-8">
                                    <label>SMTP Host</label>
                                    <input v-model="emailSetting.smtp_host" type="text" class="form-control" required>
                                </div>
                                <div class="col-md-4">
                                    <label>Port</label>
                                    <input v-model.number="emailSetting.smtp_port" type="number" class="form-control" required>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-6">
                                    <label>SMTP User</label>
                                    <input v-model="emailSetting.smtp_user" type="text" class="form-control">
                                </div>
                                <div class="col-md-6">
                                    <label>SMTP Password</label>
                                    <input v-model="emailSetting.smtp_password" type="password" class="form-control" :placeholder="emailSetting.smtp_password_set ? 'Kosongkan jika tidak diubah' : ''">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-6">
                                    <label>From Email</label>
                                    <input v-model="emailSetting.smtp_from_email" type="email" class="form-control" required>
                                </div>
                                <div class="col-md-6">
                                    <label>From Name</label>
                                    <input v-model="emailSetting.smtp_from_name" type="text" class="form-control" required>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Enkripsi</label>
                                    <select v-model="emailSetting.smtp_encryption" class="form-control" required>
                                        <option value="tls">TLS / STARTTLS (587)</option>
                                        <option value="ssl">SSL (465)</option>
                                        <option value="none">Tanpa enkripsi</option>
                                    </select>
                                </div>
                                <div class="col-md-6 d-flex align-items-end">
                                    <div class="custom-control custom-checkbox mb-2">
                                        <input v-model="emailSetting.enabled" type="checkbox" class="custom-control-input" id="smtp-enabled">
                                        <label class="custom-control-label" for="smtp-enabled">Aktifkan SMTP</label>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>API Key ZeptoMail (Email API)</label>
                                    <input v-model="emailSetting.email_api_key" type="password" class="form-control" :placeholder="email_api_key_set ? 'Terisi — kosongkan jika tidak diubah' : 'Tempel API key dari ZeptoMail (Zoho-enczapikey ...)'">
                                    <small class="text-muted d-block mt-1">
                                        Jika API key terisi, semua email dikirim via ZeptoMail API (HTTPS) — SMTP dilewati.
                                        {{ email_api_key_set ? 'API key sudah tersimpan.' : 'API key belum diatur, email menggunakan SMTP.' }}
                                    </small>
                                </div>
                            </div>
                            <br>
                            <button type="submit" class="btn btn-success"> Simpan SMTP </button>
                        </form>
                        <hr>
                        <h6>Test Email</h6>
                        <form v-on:submit.prevent="testEmailSetting" class="d-flex">
                            <input v-model="testEmail" type="email" class="form-control mr-2" placeholder="email@contoh.com" required>
                            <button type="submit" class="btn btn-outline-primary" style="white-space: nowrap;">Kirim Test</button>
                        </form>
                    </div>
                </div>
            </div>
            <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                <center>
                    <div class="spinner-border spinner" role="status"></div>
                </center>
            </div>
        </div>
    </div>

</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                isLoading: true,
                analytics: {},
                device: [],
                packages: [],
                setting: {
                    sender_device_id: "",
                    sender_device_id_backup: "",
                    wa_api_device_id: ""
                },
                emailSetting: {
                    smtp_host: "",
                    smtp_port: 587,
                    smtp_user: "",
                    smtp_password: "",
                    smtp_from_email: "",
                    smtp_from_name: "Whacenter",
                    smtp_encryption: "tls",
                    enabled: false,
                    smtp_password_set: false,
                },
                testEmail: "",
                popup: {
                    new_file: "",
                    expired_at: moment().format("YYYY-MM-DD"),
                },
                announcement: {
                    expired_at: moment().format("YYYY-MM-DD"),
                }
            }
        },
        mounted() {
            this.getDevice({
                status: "all"
            })
            // this.getPackage()

            this.loadData()
        },
        computed: {
            email_api_key_set() {
                return !!(this.emailSetting.email_api_key_original && this.emailSetting.email_api_key_original.length > 0)
            }
        },
        methods: {
            async loadData() {
                try {
                    let setting = await this.$store.dispatch("admin_setting")
                    this.setting = setting.data.data.setting

                    let emailSetting = await this.$store.dispatch("admin_email_setting")
                    this.emailSetting = {
                        ...emailSetting.data.data.setting,
                        smtp_password: "",
                        email_api_key: "",
                        email_api_key_original: emailSetting.data.data.setting.email_api_key || "",
                    }
                    // this.announcement = setting.data.data.announcement
                    // this.popup = setting.data.data.popup

                    // this.announcement.expired_at = this.announcement.expired_at ? moment.utc(this.announcement
                    //     .expired_at).local().format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
                    // this.popup.expired_at = this.popup.expired_at ? moment.utc(this.popup.expired_at).local()
                    //     .format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")

                    this.isLoading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
            async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices
            },
            async getPackage() {
                try {
                    let res = await this.$store.dispatch('package_list')
                    this.packages = res.data.data.packages
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
            async updateEmailSetting() {
                try {
                    let payload = { ...this.emailSetting }
                    delete payload.email_api_key_original
                    let response = await this.$store.dispatch('admin_email_setting_update', payload)
                    this.$toast.success(response.data.message)
                    this.isLoading = true
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
            async testEmailSetting() {
                try {
                    let response = await this.$store.dispatch('admin_email_setting_test', {
                        recipient_email: this.testEmail,
                    })
                    this.$toast.success(response.data.message)
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
            async updateSetting() {
                try {
                    this.setting.komisi_referral = parseFloat(this.setting.komisi_referral)
                    this.setting.komisi_agency = parseFloat(this.setting.komisi_agency)
                    this.setting.withdraw_fee = parseFloat(this.setting.withdraw_fee)
                    let response = await this.$store.dispatch('admin_setting_update', this.setting)
                    this.$toast.success(response.data.message);

                    this.isLoading = true
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async updateAnnouncement() {
                try {
                    let response = await this.$store.dispatch('admin_announcement_update', {
                        text: this.announcement.text,
                        expired_at: parseInt(moment(this.announcement.expired_at).utc().valueOf())
                    })
                    this.$toast.success(response.data.message);

                    this.isLoading = true
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async updatePopup() {
                try {
                    let url = this.popup.file ?? ""
                    if (this.popup.new_file) {
                        const formData = new FormData();

                        formData.append('file', this.popup.new_file)
                        let response = await this.$store.dispatch('cdn_upload', formData)
                        url = response.data.data.url
                    }

                    let response = await this.$store.dispatch('admin_popup_update', {
                        title: this.popup.title,
                        text: this.popup.text,
                        file: url,
                        expired_at: parseInt(moment(this.popup.expired_at).utc().valueOf())
                    })
                    this.$toast.success(response.data.message);

                    this.isLoading = true
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            onFileChange(e) {
                const selectedFile = e.target.files[0];
                this.popup.new_file = selectedFile;
            },
            formatNumber(numb) {
                const format = numb.toString().split('').reverse().join('');
                const convert = format.match(/\d{1,3}/g);
                return convert.join('.').split('').reverse().join('')
            },
            formatRupiah(numb) {
                const format = numb.toString().split('').reverse().join('');
                const convert = format.match(/\d{1,3}/g);
                const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')
                return rupiah
            },
        }
    }
</script>